import {
  useMutation,
  UseMutationOptions,
  DefaultError
} from '@tanstack/react-query';

import {
  postLoginGoogle,
  PostLoginGoogleRequest,
  PostLoginGoogleBackendResponse
} from '~/lib/services/api/user';

// Tipo para la respuesta transformada que esperan los componentes
type GoogleLoginData = {
  data: {
    email: string
    userName: string
    accessToken: string
    refreshToken: string
  }
}

function useGoogleLogin () {
  const mutationFn = async (
    newData: PostLoginGoogleRequest
  ): Promise<GoogleLoginData> => {
    const response = await postLoginGoogle(newData);
    // Adaptar la respuesta del backend que tiene estructura: { status_code, content: { data } }
    // a la estructura esperada por el frontend: { data }
    if (
      response.data &&
      typeof response.data === 'object' &&
      'content' in response.data
    ) {
      const backendResponse =
        response.data as unknown as PostLoginGoogleBackendResponse;
      if (backendResponse.content && backendResponse.content.data) {
        return { data: backendResponse.content.data };
      }
    }
    // Fallback si la respuesta no tiene la estructura esperada
    throw new Error('Invalid response structure from backend');
  };

  const options: UseMutationOptions<
    GoogleLoginData,
    DefaultError,
    PostLoginGoogleRequest,
    unknown
  > = {
    mutationFn
  };

  return useMutation(options);
}

export default useGoogleLogin;
